import styled from "styled-components";
import FlexBox from "../../Components/FlexBox/FlexBox";
import { responsiveMap } from "../../Components/Grid/_utils/responsiveObserve";

export const _NavigationMenuRoot = styled(FlexBox)<{}>(() => {
  return {
    cursor: "pointer",
    overflow: "hidden",
    whiteSpace: "nowrap",
    position: "relative",
    ["> .ro-flexbox"]: {
      whiteSpace: "nowrap",
      maxWidth: "100%",
    },
    [".ro-typography"]: {
      whiteSpace: "pre-wrap",
      wordBreak: "break-all",
    },
    ["em, strong"]: {
      fontStyle: "normal",
    },
    ["@media screen and (max-width: 1280px)"]: {
      ["em"]: {
        display: "none",
      },
    },
    [`@media ${responsiveMap.mobile}`]: {
      ".menu-icon": {
        color: "white",
      },
      "& .d-desktop": {
        display: "none",
      },
      "& .d-mobile": {
        display: "unset",
      },
    },

    "& .d-mobile": {
      display: "none",
    },

    "&.clamped": {
      maxWidth: 24,
    },
  };
});

export const _NavigationMenuDiv = styled("div")(() => {
  return {
    [`@media ${responsiveMap.mobile}`]: {
      "& .d-desktop": {
        display: "none",
      },
      "& .d-mobile": {
        display: "unset !important",
      },
    },

    "& .d-mobile": {
      display: "none",
    },
  };
});
